import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'

// 引入全局css文件
import '@/assets/css/all.css'

// 引入axios
import axios from 'axios'
// 挂载后台数据
Vue.prototype.$http = axios;
axios.defaults.baseURL = "http://117.68.119.24:9999/api"
// 本地
// axios.defaults.baseURL = "http://10.250.251.113:9999/api"
// axios.defaults.baseURL = "http://10.250.251.106:9999/api"

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
